var React = require('react');

function DashBox (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.84424 1.92493H473.121L594.067 103.503V443H1.84424V1.92493Z","stroke":"#2A87F5","strokeWidth":"2","strokeDasharray":"48 8 8 8 8 8","strokeDashoffset":"-80","vectorEffect":"non-scaling-stroke"}));
}

DashBox.defaultProps = {"width":"596","height":"444","viewBox":"0 0 596 444","fill":"none","preserveAspectRatio":"none"};

module.exports = DashBox;

DashBox.default = DashBox;
